import React, { useCallback, useState } from "react";
import Snackbar from "react-toolbox/lib/snackbar";
import { useBrandBlockStatus } from "util/hooks/useBrandBlockStatus";
import InviteMessage from "./messaging-thread-item-invite";
import NormalMessage from "./messaging-thread-item-normal";

/**
 * MessageThreadItem component
 * @param {object} props Component props
 * @param {object} [props.message] Message object
 * @param {number?} [props.seenBy] Number of users who have seen the message
 * @returns {import("react").ReactElement} MessageThreadItem component
 */
export default function MessageThreadItem(props) {
  const { message } = props;

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarActive, setSnackbarActive] = useState(false);
  const [snackbarType, setSnackbarType] = useState("success");

  const { isBlocked, toggleBlock } = useBrandBlockStatus(message.brand_id);

  // Toast notification helper
  const showMessage = useCallback((message, type = "success") => {
    setSnackbarMessage(message);
    setSnackbarType(type);
    setSnackbarActive(true);
  }, []);

  const handleToggleBlock = () => {
    const wasBlocked = isBlocked;

    // Show success message
    toggleBlock(() => {
      showMessage(
        wasBlocked ? "Brand unblocked successfully" : "Brand blocked successfully",
        "success",
      );
    });
  };

  return (
    <>
      {message.messageType === "normal" ? (
        <NormalMessage key={message.id} {...props} />
      ) : (
        <InviteMessage
          key={message.id}
          isBlocked={isBlocked}
          toggleBlock={handleToggleBlock}
          {...props}
        />
      )}
      <Snackbar
        action="Dismiss"
        active={snackbarActive}
        label={snackbarMessage}
        timeout={3000}
        onTimeout={() => setSnackbarActive(false)}
        onClick={() => setSnackbarActive(false)}
        type={snackbarType}
      />
    </>
  );
}
